import { useField } from "formik";
import { MelcoModelsUserProductListItem } from "melco-shared-logic";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";

export const useAssignUnassignProducts = () => {
  const { t } = useTranslation();

  const [{ value: products }, , { setValue: setProducts, setError }] =
    useField<MelcoModelsUserProductListItem[]>("product_list");

  const isAlreadyAdded = (product: MelcoModelsUserProductListItem) =>
    product.code && products.find((d) => d.code === product.code);

  const addProducts = useCallback(
    (toAdd: MelcoModelsUserProductListItem[]) => {
      const addedProducts = toAdd
        .filter((d) => !isAlreadyAdded(d))
        .map((product) => {
          const { code, name } = product;

          return {
            code,
            name,
          };
        });

      setProducts([...(products ?? []), ...addedProducts]);

      // message.success(
      //   t("libraries.product_collections.actions.add_products.actions.added", {
      //     count: addedProducts.length,
      //   })
      // );
    },
    [products, setProducts, t]
  );

  const removeProducts = useCallback(
    (toRemove: { code: string }[]) => {
      const idsToRemove = toRemove.map((d) => d.code);

      setProducts(products.filter((d) => !idsToRemove.includes(d.code!)));

      // reset field error as removing a field changes the index positions which could lead to errors being assigned to the wrong field
      setError(undefined);
    },
    [products, setProducts, setError]
  );

  return {
    products,
    addProducts,
    removeProducts,
    isAlreadyAdded,
  };
};
